<script setup lang="ts">
/**
 * Table cell listing names stacked vertically, each colored by gender
 * (`--color-gender-men` / `--color-gender-women`) — the desktop counterpart
 * of the color-coded performer names in `ServiceMobileCardCell`. Shows
 * `emptyPlaceholder` (muted) when the list is empty.
 */
import type { GenderBucket } from '@/utils/gender'

defineProps<{
  /** Names to render, one per line. */
  items?: readonly { id: string; name: string; gender: GenderBucket }[]
  /** Shown muted when `items` is empty. */
  emptyPlaceholder?: string
  /** Max width of the cell (CSS value). Set by DynamicTable from column config. */
  maxWidth?: string
}>()
</script>

<template>
  <td
    class="font-tufte"
    :style="maxWidth ? { maxWidth: maxWidth, overflowWrap: 'break-word' } : undefined"
  >
    <template v-if="items && items.length > 0">
      <div
        v-for="item in items"
        :key="item.id"
        class="gender-name-list-cell__item"
        :class="`gender-name-list-cell__item--${item.gender}`"
      >
        {{ item.name }}
      </div>
    </template>
    <span v-else class="text-tufte-muted">{{ emptyPlaceholder ?? '–' }}</span>
  </td>
</template>

<style scoped>
.gender-name-list-cell__item + .gender-name-list-cell__item {
  margin-top: 0.15rem;
}

.gender-name-list-cell__item--men {
  color: var(--color-gender-men);
}

.gender-name-list-cell__item--women {
  color: var(--color-gender-women);
}
</style>
